interface BookingReasonConfigProps {
  data: any;
  onChange: (updates: any) => void;
}

export function BookingReasonConfig({ data, onChange }: BookingReasonConfigProps) {
  const requireReason = !!data.requireBookingReason;
  const reasonLabel = data.bookingReasonLabel || 'Raison de la réservation';

  return (
    <div>
      <label
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: '1rem',
          padding: '1.25rem',
          background: requireReason ? 'rgba(223,195,47,0.05)' : 'white',
          border: `2px solid ${requireReason ? '#dfc32f' : '#e5e7eb'}`,
          borderRadius: '12px',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
        }}
        onMouseEnter={(e) => {
          if (!requireReason) {
            e.currentTarget.style.borderColor = '#dfc32f';
            e.currentTarget.style.background = 'rgba(223,195,47,0.02)';
          }
        }}
        onMouseLeave={(e) => {
          if (!requireReason) {
            e.currentTarget.style.borderColor = '#e5e7eb';
            e.currentTarget.style.background = 'white';
          }
        }}
      >
        <input
          type="checkbox"
          checked={requireReason}
          onChange={(e) => onChange({ requireBookingReason: e.target.checked })}
          style={{
            width: '20px',
            height: '20px',
            marginTop: '2px',
            cursor: 'pointer',
            accentColor: '#dfc32f',
          }}
        />
        <div style={{ flex: 1 }}>
          <div
            style={{
              fontSize: '1rem',
              fontWeight: 600,
              color: '#00303c',
              marginBottom: '0.25rem',
            }}
          >
            Demander la raison de la réservation
          </div>
          <div style={{ fontSize: '0.9rem', color: '#666' }}>
            Si activé, un champ texte sera ajouté pour que le client explique la raison de sa réservation
          </div>
        </div>
      </label>

      {requireReason && (
        <div
          style={{
            marginTop: '1rem',
            marginLeft: '3rem',
            animation: 'fadeIn 0.3s ease',
          }}
        >
          <label
            style={{
              display: 'block',
              marginBottom: '0.5rem',
              fontSize: '0.9rem',
              fontWeight: 600,
              color: '#00303c',
            }}
          >
            Label du champ
          </label>
          <input
            type="text"
            value={reasonLabel}
            onChange={(e) => onChange({ bookingReasonLabel: e.target.value })}
            placeholder="Ex: Raison de la réservation, Objet de la demande..."
            style={{
              width: '100%',
              maxWidth: '400px',
              padding: '0.875rem 1rem',
              fontSize: '1rem',
              border: '2px solid #e5e7eb',
              borderRadius: '12px',
              outline: 'none',
              transition: 'all 0.2s ease',
            }}
            onFocus={(e) => {
              e.currentTarget.style.borderColor = '#00758d';
              e.currentTarget.style.boxShadow = '0 0 0 4px rgba(0,117,141,0.1)';
            }}
            onBlur={(e) => {
              e.currentTarget.style.borderColor = '#e5e7eb';
              e.currentTarget.style.boxShadow = 'none';
            }}
          />
          <p style={{ fontSize: '0.85rem', color: '#666', marginTop: '0.5rem' }}>
            Ce texte sera affiché comme label du champ dans le formulaire client
          </p>
        </div>
      )}
    </div>
  );
}
